document.addEventListener('click', function (e) {
    const fila = e.target.closest('.trSelectConsumido');
    if (!fila) return;

    const idConsumido = fila.dataset.id;
    const idReporte   = fila.dataset.idReporte;

    const inputId      = document.getElementById('idLineaEntregaPaquetesConsumidosEditar');
    const inputReporte = document.getElementById('idReporteSopladoEditarConsumido');

    if (inputId)      inputId.value      = idConsumido;
    if (inputReporte) inputReporte.value = idReporte;

    fetch(`/api/soplado/info-entrega-consumido?idLine=${idConsumido}`, {
        method: 'GET',
        credentials: 'include'
    })
    .then(r => r.json())
    .then(json => {
        const d = Array.isArray(json.result) ? json.result[0] : json.result;
        if (!d) return;

        const elLote = document.getElementById('loteEditar');
        const elCant = document.getElementById('cantPaquetesConsumidoEditar');
        const elUnd  = document.getElementById('cantUnidadesConsumidoEditar');

        if (elLote) elLote.value = d.lote ?? '';
        if (elCant) {
            const paq = d.cantPaquetes != null ? Number(d.cantPaquetes) : 0;
            const unidadEmpaque = d.unidadEmpaque != null ? Number(d.unidadEmpaque) : 140;
            elCant.value = new Intl.NumberFormat('en-US').format(paq);
            if (elUnd) elUnd.value = new Intl.NumberFormat('en-US').format(paq * unidadEmpaque);
        }
    })
    .catch(err => console.error('Error al cargar consumido:', err));
});

document.addEventListener('submit', function (e) {
    const form = e.target.closest('#formEditarConsumidoSoplado');
    if (!form) return;
    e.preventDefault();

    modal = form.closest('.modal');

    const btnSubmit = form.querySelector('[type="submit"]');
    if (btnSubmit) btnSubmit.disabled = true;

    const data = new FormData(form);

    fetch('/api/soplado/editar-entrega-consumido', {
        method: 'POST',
        credentials: 'include',
        body: data
    })
    .then(r => r.json())
    .then(json => {
        const resultado = json.result ?? '';
        const errores = resultado.errores ?? [];
        errores.forEach(e => {
            lanzarAlerta(e.mensaje, e.clase);
            const campo = form.querySelector('[name="' + e.campo + '"]');
            if (campo) campo.classList.add('inputRojo');
        });

        if (!resultado.hayErrores) {
            const idReporte = document.getElementById('idReporteSopladoEditarConsumido').value;
            form.reset();
            modal.classList.remove('modal--show');
            if (idReporte && typeof window.actualizarTablaConsumido === 'function') {
                window.actualizarTablaConsumido(idReporte);
            }
            if (typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
            lanzarAlerta('Paquete consumido editada correctamente.', 'alerta-verde');
        }
    })
    .catch(() => lanzarAlerta('Error al conectar con el servidor.', 'alerta-roja'))
    .finally(() => { if (btnSubmit) btnSubmit.disabled = false; });
});
